import React from 'react';
import { ClusterGroupInput } from '../../components/input/ClusterGroupInput';
import { ScaffolderField } from '@backstage/plugin-scaffolder-react/alpha';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const ClusterGroup = ({
  onChange,
  schema: { title, description },
  required,
  disabled,
  rawErrors,
  errors,
  formData,
  idSchema,
  formContext,
}: FieldExtensionComponentProps<string>) => {
  return (
    <ScaffolderField
      rawErrors={rawErrors}
      rawDescription={description}
      disabled={disabled}
      errors={errors}
      required={required}
    >
      <ClusterGroupInput
        label={title}
        helperText={description}
        error={rawErrors && rawErrors.length > 0 && !formData}
        required={required}
        id={idSchema?.$id}
        onChange={onChange}
        product={formContext.formData.product}
        provider={formContext.formData.provider}
        team={formContext.formData.team}
        value={formData as string}
      ></ClusterGroupInput>
    </ScaffolderField>
  );
};
